import React, { useCallback, useEffect, useState } from "react";
import { Package, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function StockManager() {
  const [products, setProducts] = useState([]);

  const load = useCallback(async () => {
    try { const res = await api.get("/admin/bar/products"); setProducts(res.data); } catch (e) { /* ignore */ }
  }, []);
  useEffect(() => { load(); }, [load]);

  const setStock = (id, v) => setProducts((prev) => prev.map((p) => (p.id === id ? { ...p, stock: v } : p)));

  const save = async (p) => {
    const stockVal = p.stock === "" || p.stock === null || p.stock === undefined ? null : Number(p.stock);
    try {
      await api.patch(`/admin/bar/products/${p.id}`, {
        name: p.name, description: p.description || "", category: p.category || "",
        price: Number(p.price) || 0, cost: Number(p.cost) || 0, stock: stockVal, active: !!p.active,
      });
      toast.success("Estoque salvo.");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="stock-manager">
      <div className="flex items-center gap-2">
        <Package className="h-5 w-5 text-[#0891b2]" />
        <h2 className="font-display text-xl font-bold tracking-tight text-slate-900">Estoque dos produtos</h2>
      </div>
      <p className="mt-1 text-sm text-slate-500">Deixe em branco para estoque ilimitado. Ao chegar a 0, o produto fica "Esgotado" no cardápio.</p>
      <div className="mt-4 space-y-2">
        {products.map((p) => {
          const tracked = p.stock !== null && p.stock !== undefined && p.stock !== "";
          const out = tracked && Number(p.stock) <= 0;
          return (
            <div key={p.id} data-testid={`stock-row-${p.id}`} className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-3">
              <div className="min-w-0 flex-1">
                <p className="font-display font-bold text-slate-900">{p.name}</p>
                <p className="text-xs text-slate-400">{p.category || "—"}{out && <span className="ml-2 font-bold text-red-600">ESGOTADO</span>}</p>
              </div>
              <Input data-testid={`stock-input-${p.id}`} type="number" placeholder="∞" value={p.stock ?? ""} onChange={(e) => setStock(p.id, e.target.value)} className="w-24 rounded-xl" />
              <Button data-testid={`stock-save-${p.id}`} onClick={() => save(p)} size="sm" className="rounded-full bg-[#1B7A45] text-white hover:bg-[#156337]"><Save className="h-4 w-4" /></Button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
